import request, { getRequest, postRequest, fileUpload } from './request'

/**
 * 用户登录
 * @returns {string}
 */
export function loginAdminUser(loginForm) {
	return postRequest('/user/login', loginForm)
}
export function userChangePassword(params) {
	return getRequest('/user/changePassword', params)
}
export function requestListCountries() {
	return getRequest("/user/listCountries")
}
export function test() {
	return getRequest('/test/t2', {})
}

export function users(params) {
	return getRequest('/user/list', params)
}
export function feedbacks(params) {
	return getRequest('/user/feedback', params)
}
export function feedbackdelete(params) {
	return getRequest('/user/feedback/delete', params)
}
export function updateFeedbackStatus(params) {
	return getRequest('/user/updateFeedbackStatus', params)
}
export function requestUserDetail(params) {
	return getRequest('/user/detail', params)
}
export function requestDeviceHistory(params) {
	return getRequest('/user/device/history', params)
}

export function requestUserDeviceList(params) {
	return getRequest('/user/deviceList', params)
}

export function requestUserCollect(params) {
	return getRequest('/user/collect', params)
}
export function requestUserFollower(params) {
	return getRequest('/user/follower', params)
}
export function requestUserHealthData(params) {
	return getRequest('/user/healthData', params)
}
export function requestUserBpData(params) {
	return getRequest('/user/bpData', params)
}
export function requestUserHrData(params) {
	return getRequest('/user/hrData', params)
}
export function requestUserHrvData(params) {
	return getRequest('/user/hrvData', params)
}
export function requestUserBoData(params) {
	return getRequest('/user/boData', params)
}
export function requestUserSleepData(params) {
	return getRequest('/user/sleepData', params)
}
export function requestUserSportData(params) {
	return getRequest('/user/sportData', params)
}
export function requestUserStepData(params) {
	return getRequest('/user/stepData', params)
}
export function requestUserHeatData(params) {
	return getRequest('/user/heatData', params)
}

export function requestUserAdminList(params) {
	return getRequest('/user/admin/list', params)
}
export function requestUserRoleList(params) {
	return getRequest('/user/roleList', params)
}
export function userAddRole(params) {
	return postRequest('/user/addRole', params)
}
export function requestUserPermissionList(params) {
	return getRequest('/user/permissionList', params)
}
export function userEditRole(params) {
	return postRequest('/user/editRole', params)
}
export function requestUserRemoveRole(params) {
	return getRequest('/user/removeRole', params)
}
export function requestUserListRolePermissions(params) {
	return getRequest('/user/listRolePermissions', params)
}
export function userAddAdmin(params) {
	return postRequest('/user/addAdmin', params)
}
export function userEditAdmin(params) {
	return fileUpload('/user/editAdmin', params)
}
export function requestUserRemoveAdmin(params) {
	return getRequest('/user/removeAdmin', params)
}
export function requestUserWeightData(params) {
	return getRequest('/user/weightData', params)
}
export function requestUserImportantMetrics(params) { //昨日关键指标
	return getRequest('/user/importantMetrics', params)
}
export function requestUserGroupData(params) {//用户分析 环形图数据
	return getRequest('/user/groupData', params)
}
export function requestUserLineChartData(params) {//用户分析 折线图数据
	return getRequest('/user/lineChartData', params)
}
export function requestuserFeedbackCount(params) {//用户反馈数量
	return getRequest('user/feedback/count', params)
}
export function userListFeedbackTypes(params) {//用户反馈类型列表
	return getRequest('user/listFeedbackTypes', params)
}
export function userFeedbackDetail(params) {//用户反馈详情
	return getRequest('/user/feedback/detail', params)
}
export function userPostMessage(params) {
	return postRequest('/user/postMessage', params)
}
export function userChat(params) {//用户反馈详情
	return getRequest('/user/chat', params)
}
export function userAssumeRole() {//获取oss令牌
	return getRequest('/user/assumeRole')
}

export function redeemList(params) {//兑换码列表
	return getRequest('/vip/exchange/code/list', params)
}

export function redeemRepeal(params) {//兑换码作废
	return postRequest('/vip/exchange/code/void', params)
}

export function redeemAdd(params) {//兑换码生成
	return postRequest('/vip/exchange/code/add', params)
}

export function redeemEmail(params) {//发送兑换码
	return postRequest('/vip/exchange/code/email', params)
}

export function vipList(params) {//会员中心
	return getRequest('/vip/list', params)
}

export function vipAll(params) {//会员中心
	return getRequest('/vip/all', params)
}


export function userVipList(params) {//会员信息
	return getRequest('/user/vip/list', params)
}


